// -- [Role-specific section - only shown for the active role]

import type { SectionCopy } from '@/types/content'

interface RoleSectionProps {
  section: SectionCopy
}

export function RoleSection({ section }: RoleSectionProps) {
  return (
    <section id={section.id} className="py-12 px-6">
      <div className="max-w-4xl mx-auto border-l-4 border-brand-orange pl-6">
        <h2 className="text-2xl font-bold text-gray-900 mb-2">{section.title}</h2>
        <p className="text-gray-600 mb-6">{section.summary}</p>
        {section.features.length > 0 && (
          <ul className="space-y-2">
            {section.features.map((f, i) => (
              <li key={i} className="flex items-start gap-2">
                <span className="text-brand-orange mt-1">✓</span>
                <span className="text-gray-700">{f}</span>
              </li>
            ))}
          </ul>
        )}
      </div>
    </section>
  )
}
